import {
  Message
} from 'element-ui'

export const timeToLocal = (date) => {
  if (!date) return {};
  const datetmp = `${date.getFullYear()}-${
    date.getMonth() + 1 >= 10
      ? date.getMonth() + 1
      : `0${date.getMonth() + 1}`
  }-${date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`}`;
  const time = `${
    date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`
  }:${
    date.getMinutes() >= 10 ? date.getMinutes() : `0${date.getMinutes()}`
  }:${
    date.getSeconds() >= 10 ? date.getSeconds() : `0${date.getSeconds()}`
  }`;
  const datetime = `${datetmp} ${time}`;
  return {
    date: datetmp,
    time,
    datetime
  };
};

export const uuid = () => {
  let surveyId = window.localStorage.getItem('survey_id') || '';
  let d = new Date().getTime();
  const id = "xxxxxxxx-yxxx".replace(
    /[xy]/g,
    c => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return surveyId + '-' + id;
};


export const getParams = (key) => {
  const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
  const result = window.location.search.substr(1).match(reg);
  if (result != null) {
    return decodeURIComponent(result[2]);
  }
  return null;
};

export const removeLables = (html) => {
  if (!html) return '';
  return html.replace(/<\/?.+?>/g, '');
};

const HTMLDecode = (text) => {
  var temp = document.createElement("div");
  temp.innerHTML = text;
  var output = temp.innerText || temp.textContent;
  temp = null;
  return output;
};

export const htmlRemoveLables = (html) => {
  let text = HTMLDecode(html).replace(/<\/?.+?>/g,"");
  return text;
};

export const getTitle = (title) => {
  const dom = document.createElement("p");
  dom.innerHTML = title;
  return dom.textContent;
};

export const deepClone = (
  original,
  target = Object.prototype.toString.call(original) === "[object Array]" ? [] : {}
) => {
  for (const prop in original) {
    if (original.hasOwnProperty(prop)) {
      if (typeof original[prop] === "object") {
        if (
          Object.prototype.toString.call(original[prop]) ===
          "[object Array]"
        ) {
          target[prop] = [];
        } else {
          target[prop] = {};
        }
        deepClone(original[prop], target[prop]);
      } else {
        target[prop] = original[prop];
      }
    }
  }
  return target;
};


export const getTimestamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const second = now.getSeconds();
  const milliSecond = now.getMilliseconds();
  return "" + year + month + date + hour + minute + second + milliSecond;
}

export const getDateRange = (range) => {
  const endTime = timeToLocal(new Date()).date;
  let _date = endTime.replace(/\-/g, "/");
  let _endTime = new Date(_date).getTime();
  let startDate = new Date(_endTime - 24 * 3600 * 1000 * range)
  let startTime =  timeToLocal(startDate).date;
  return {
    startTime,
    endTime
  };
}

export const exportFile = (fileName, content) => {
  let eleLink = document.createElement("a");
  eleLink.download = fileName + ".txt";
  eleLink.style.display = "none";
  // 字符内容转变成blob地址
  let blob = new Blob([content]);
  eleLink.href = URL.createObjectURL(blob);
  document.body.appendChild(eleLink);
  eleLink.click();
  document.body.removeChild(eleLink);
}

export const MSG = {
  success(msg) {
    Message({
      type: "success",
      message: msg
    });
  },
  error(msg) {
    Message({
      type: "error",
      message: msg
    });
  },
  warning(msg) {
    Message({
      type: "warning",
      message: msg
    });
  }
}


/**
 * 获取指定的 url 参数
 * @param str
 * @param paramName
 */
export function getUrlParameter(str, paramName) {
  if (!str) { return null }
  let queryString = str
  if (queryString.length > 1 && queryString[0] === '?') {
    queryString = queryString.slice(1)
  }
  const params = queryString.split('&')
  for (let i = 0; i < params.length; i += 1) {
    const val = params[i].split('=')
    if (val[0] === paramName) {
      return val[1]
    }
  }
  return null
}
/**
 * 生成带参数的 url
 * @param baseUrl
 * @param params
 */
export function getStringifyUrl(baseUrl, params = {}) {
  const arr = []
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null) {
      arr.push(`${key}=${params[key]}`)
    }
  })
  return arr.length ? `${baseUrl}?${arr.join('&')}` : baseUrl
}


// WEBPACK FOOTER //
// ./src/utils/utils.js